const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  roles: state => state.user.roles,
  actions: state => state.user.actions,
  userid: state => state.user.userid,
  // adminuser
  adminuserTotal: state => state.adminuser.total,
  adminuserRows: state => state.adminuser.rows,
  adminuserRow: state => state.adminuser.row,
  adminuserFiles: state => state.adminuser.files,
  adminuserTabs: state => state.adminuser.tabs,
  // news
  newsTotal: state => state.news.total,
  newsRows: state => state.news.rows,
  newsRow: state => state.news.row,
  // company
  companyTotal: state => state.company.total,
  companyRows: state => state.company.rows,
  companyCrm: state => state.company.crm,
  companyRow: state => state.company.row,
  companyGroupRows: state => state.company.grouprows,
  companyDicts: state => state.company.dicts,
  // permission
  addRoutes: state => state.permission.addRoutes,
  permission_routes: state => state.permission.routes,
  // bdnote
  bdnoteTotal: state => state.bdnote.total,
  bdnoteRows: state => state.bdnote.rows,
  // data
  dataRow: state => state.data.row,
  dataRows: state => state.data.rows,
  dataTotal: state => state.data.total,
  // app
  appRow: state => state.data.row,
  appRows: state => state.data.rows,
  appTotal: state => state.data.total,
  // trade
  tradeRow: state => state.trade.row,
  tradeRows: state => state.trade.rows,
  tradeTotal: state => state.trade.total,
  // visualTotalTime: state => state.trade.totaltime,
  tradeAssemblyList: state => state.trade.assemblyList,
  tradeAssemblyQuantity: state => state.trade.quantity,
  tradeExporters: state => state.trade.exporters,
  retail: state => state.trade.retail,
  chatRows: state => state.trade.chatRows,
  chatTotal: state => state.trade.chatTotal,
  // setting
  settingRow: state => state.setting.row,
  settingRows: state => state.setting.rows,
  // notes
  notesRow: state => state.notes.row,
  notesRows: state => state.notes.rows,
  notesTotal: state => state.notes.total,
  notesStatus: state => state.notes.status,
  newFileStatus: state => state.notes.fileStatus,
  newAppealStatus: state => state.notes.appealStatus,
  newUnAppealStatus: state => state.notes.appealUnStatus,
  newAgencyStatus: state => state.notes.agencyStatus,
  newUnAgencyStatus: state => state.notes.agencyUnStatus,
  newPurchaseStatus: state => state.notes.purchaseStatus,
  newSaleStatus: state => state.notes.saleStatus,
  newReimbursementStatus: state => state.notes.reimbursementStatus,
  newCashRequirementStatus: state => state.notes.cashRequirementStatus,
  // price
  priceRows: state => state.price.rows,
  priceTotal: state => state.price.total,
  // trend
  trendRows: state => state.trend.rows,
  trendTotal: state => state.trend.total,
  // cuts
  cutsRow: state => state.cuts.row,
  cutsRows: state => state.cuts.rows,
  cutsTotal: state => state.cuts.total,
  cutsDatas: state => state.cuts.datas,
  // circle
  circleReviews: state => state.trade.reviews,
  // newdata
  newdataRow: state => state.newdata.rows,
  // financial
  financialTotal: state => state.financial.total,
  financialRows: state => state.financial.rows,
  financialCrm: state => state.financial.crm,
  financialRow: state => state.financial.row,
  financialGroupRows: state => state.financial.grouprows,
  financialDicts: state => state.financial.dicts,
  financialCompanyRows: state => state.financial.financialCompany,
  // accounting
  accountingTotal: state => state.accounting.total,
  accountingRow: state => state.accounting.row,
  accountingRows: state => state.accounting.rows,
  accountingRedDot: state => state.accounting.redDot,
  accountingDatas: state => state.accounting.datas,
  accountingAmount: state => state.accounting.amount,
  // contract
  contractTotal: state => state.contract.total,
  contractRow: state => state.contract.row,
  contractRows: state => state.contract.rows,

  contractBuyerOrSeller: state => state.contract.buyerOrSeller,
  contractFileData: state => state.contract.fileData,
  contractDatas: state => state.contract.datas,
  contractTabs: state => state.contract.tabs,
  contractShow: state => state.contract.isShow,
  // 上传PDF
  reportRows: state => state.report.rows,
  reportTotal: state => state.report.total,
  // 用户异议
  opinionRows: state => state.price.rows,
  opinionTotal: state => state.price.total,
  // 直播
  visualNoiceRows: state => state.visual.rows,
  visualNoiceRow: state => state.visual.row,
  visualNoiceTotal: state => state.visual.total,
  visualPeopleRows: state => state.visual.rows,
  visualPeopleRow: state => state.visual.row,
  visualTotalTime: state => state.visual.totaltime,
  visualPeopleTotal: state => state.visual.total,
  priceDataIndexRows: state => state.visual.rows,
  priceDataIndexRow: state => state.visual.row,
  priceDataIndexTotal: state => state.visual.total,
  advertisement: state => state.advertisement
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js